import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import { publicRoutes } from "./Routes";
import PageNotFound from "./pages/PageNotFound";
// Component để thay đổi title theo route
function UpdateTitle() {
  const location = useLocation();

  useEffect(() => {
    const currentRoute = publicRoutes.find(route => route.path === location.pathname);
    if (currentRoute) {
      document.title = currentRoute.title || "Default Title";
    } else {
      document.title = "404 - Page Not Found";
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <Header />
      <UpdateTitle />
      <Routes>
        {publicRoutes.map((route, index) => {
          const Component = route.component;
          return <Route key={index} path={route.path} element={<Component />} />;
        })}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
